export const CARD_BORDER_RADIUS = 12;

export const PAYMENT_CARD_STYLES = {
  MARGIN_BOTTOM: 16,
  MIN_HEIGHT: 140,
  PADDING_VERTICAL: 12,
} as const;

export const PAYMENT_CARD_LOADING_STYLES = {
  MARGIN_BOTTOM: 16,
  MIN_HEIGHT: 120,
  PADDING: 20,
} as const;

export const PAYMENT_ERROR_CARD_STYLES = {
  MARGIN_BOTTOM: 16,
  MIN_HEIGHT: 100,
  PADDING_VERTICAL: 8,
} as const;


